export const LoginMode = {
  login: 'login',
  signup: 'signup',
  forgotPassword: 'forgotPassword',
};

export const LOGIN_ERROR_DEFAULT =
  'Email or profile name and password do not match';
export const LOGIN_ERROR_EMAIL = 'Unknown email address or profile name';

export const SIGNUP_ERROR_DEFAULT =
  'Signup failed, please check your credentials';
